import './IvionView.css'
import { useEffect } from "react";
import { ApiInterface, getApi } from "@navvis/ivion";
import { useHistory } from 'react-router-dom';
import { useQueryParams } from '../hooks/useQueryParams';

let api: ApiInterface;
// ID of ZAB site
const siteId = 1096871329526868;

const IvionView: React.FC = () => {
    const history = useHistory()
    const queryParams = useQueryParams();

    useEffect(() => {
        const siteQueryParam = queryParams.get("site");
        if (siteQueryParam === undefined || siteQueryParam === null) {
            return;
        }
        if (siteQueryParam === String(siteId)) {
            return;
        }
        // User pasted a link with a site ID which is not the correct site Id. Remove 
        // all the query parameters
        history.push(history.location.pathname);
    }, [queryParams, history]);

    function hasSitePermissions(user: any): boolean {
        return Object.keys(user.sitePermissions).includes(String(siteId))
    }

    useEffect(() => {
        document.getElementById('iv')?.appendChild(document.createElement('ivion'));
        loadApi();
        
        async function loadApi() {
            async function initApi(): Promise<void>{
                api = await getApi("https://qptr.iv.navvis.com/", {
                    lang: "de"
                });

                api.site.service.activeSiteSelected.connect(async (site) => {
                    if (site !== undefined) {
                        return;
                    }
                    await init(api.auth.currentUser);
                });
                api.auth.onAuthenticationChanged.connect(async (user) => {
                    if (!hasSitePermissions(user)) {
                        // Remove query parameters from current path
                        history.push(history.location.pathname);                        
                        return;
                    }
                    await init(user);
                    window.location.reload();
                })
                await init(api.auth.currentUser);
            }

            async function init(user: any): Promise<void> {
                if (!hasSitePermissions(user)) {
                    return;
                }
                if (api.site.service.activeSite?.id === siteId) {
                    return;
                }
                const site = await api.site.repository.findOne(siteId);
                api.site.service.loadSite(site);
            }

            if (api === undefined) {
                await initApi();
            }
        }
    }, [history]);

    return <div className="ivion-container" id="iv"></div>;   
};

export default IvionView;